import { render, staticRenderFns } from "./TableBodyTurns.vue?vue&type=template&id=126c8289&scoped=true"
import script from "./TableBodyTurns.vue?vue&type=script&lang=js"
export * from "./TableBodyTurns.vue?vue&type=script&lang=js"
import style0 from "./TableBodyTurns.vue?vue&type=style&index=0&id=126c8289&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126c8289",
  null
  
)

export default component.exports